import { render, staticRenderFns } from "./KanbanDayPicker.vue?vue&type=template&id=25e8dcf8&scoped=true"
import script from "./KanbanDayPicker.vue?vue&type=script&lang=js"
export * from "./KanbanDayPicker.vue?vue&type=script&lang=js"
import style0 from "./KanbanDayPicker.vue?vue&type=style&index=0&id=25e8dcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8dcf8",
  null
  
)

export default component.exports